// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0px;
  box-sizing: border-box;
}

body {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem auto;
  background: #ddd;
}

.editor-wrapper {
  /* width: 768px; */
  border: 1px solid black;
  background: #fff;
  padding: 1rem;
}

.editor-container {
  width: 100%;
  border: 1px solid green;
  padding: 1rem;
}

.toolbar-grid {
  display: flex;
  flex-wrap: wrap;
  flex-basis: 1fr 1fr;
}

button {
  margin-right: 8px;
  font-size: 1rem;
  padding: 10px;
  border: none;
  background: #fff;
  cursor: pointer;
}

.superFancyBlockquote {
  color: #999;
  background: #fff;
  font-family: "Hoefler Text", Georgia, serif;
  font-style: italic;
  border-left: 2px solid #999;
  padding-left: 10px;
}

.codeBlock {
  font-family: fira-code, monospace;
  font-size: inherit;
  background: #ffeff0;
  font-style: italic;
  word-wrap: normal;
  word-wrap: break-word;
  box-decoration-break: slice;
  padding: 0.3rem 2rem;
  border-radius: 0.2rem;
}

.leftAlign {
  text-align: left;
}
.rightAlign {
  text-align: right;
}
.centerAlign {
  text-align: center;
}
.justifyAlign {
  text-align: justify;
}
`, "",{"version":3,"sources":["webpack://./src/component/shared/DraftEditor.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB","sourcesContent":["* {\n  margin: 0px;\n  box-sizing: border-box;\n}\n\nbody {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 2rem auto;\n  background: #ddd;\n}\n\n.editor-wrapper {\n  /* width: 768px; */\n  border: 1px solid black;\n  background: #fff;\n  padding: 1rem;\n}\n\n.editor-container {\n  width: 100%;\n  border: 1px solid green;\n  padding: 1rem;\n}\n\n.toolbar-grid {\n  display: flex;\n  flex-wrap: wrap;\n  flex-basis: 1fr 1fr;\n}\n\nbutton {\n  margin-right: 8px;\n  font-size: 1rem;\n  padding: 10px;\n  border: none;\n  background: #fff;\n  cursor: pointer;\n}\n\n.superFancyBlockquote {\n  color: #999;\n  background: #fff;\n  font-family: \"Hoefler Text\", Georgia, serif;\n  font-style: italic;\n  border-left: 2px solid #999;\n  padding-left: 10px;\n}\n\n.codeBlock {\n  font-family: fira-code, monospace;\n  font-size: inherit;\n  background: #ffeff0;\n  font-style: italic;\n  word-wrap: normal;\n  word-wrap: break-word;\n  box-decoration-break: slice;\n  padding: 0.3rem 2rem;\n  border-radius: 0.2rem;\n}\n\n.leftAlign {\n  text-align: left;\n}\n.rightAlign {\n  text-align: right;\n}\n.centerAlign {\n  text-align: center;\n}\n.justifyAlign {\n  text-align: justify;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
